// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"fe640417","302":"2c6486a8","5013":"742deeb2","7320":"fe640417"}[chunkId] + ".chunk.css";
};